import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';

class CallToActonV3 extends Component {
    render() {
        return (
            <div className="ltn__call-to-action-area ltn__call-to-action-4 pt-115 pb-120 mb-120"
                style={{ backgroundColor: "#975D23" }}>  {/* Ajout du background color */}
                
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="call-to-action-inner call-to-action-inner-4 text-center">
                                <div className="section-title-area ltn__section-title-2">
                                    <h4 style={{ color: 'white' }}>
                                        Sur Keurgui, nous vérifions rigoureusement les documents officiels, collaborons avec des experts pour assurer leur conformité et sécurisons chaque échange afin de garantir des transactions immobilières fiables et transparentes.
                                    </h4>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CallToActonV3;
